module.exports = __webpack_public_path__ + "media/images/page/labo-03-4438f0b0e75776c8f2ca9e960a00fa2b.webp";